import { Router, CanLoad, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataService } from '../../user-detail.service';
import { environment } from './../../../environments/environment';

@Injectable()
export class AdminGuard implements CanLoad, CanActivate {
    authURL = `${environment.AUTH_URL}/home?action=issue&redirectUrl=${environment.REDIRECT_URL}`;
    constructor(
        private router: Router,
        private dataService: DataService
    ) { }

    canActivate(): boolean | Observable<boolean> {
      let individualSettings = this.dataService.getIndividualSettings;

        if (individualSettings && individualSettings.is_admin) {
          return true;
        } else {
            this.router.navigate(['/attendance-record']);
            return false;
        }
    }

    canLoad(): boolean | Observable<boolean> {
      let individualSettings = this.dataService.getIndividualSettings;

        if (individualSettings && individualSettings.is_admin) {
          return true;
        } else {
          this.router.navigate(['/attendance-record']);
          return false;
        }
    }
}
